<template>
  <p v-if="kind === 'stop'" class="fu-dro fu-dro--stop" data-test="fu-drawer-outcome-note">This outcome stops all future follow-ups for {{ firstName || 'this patient' }}.</p>
  <p v-else-if="kind === 'done'" class="fu-dro fu-dro--done" data-test="fu-drawer-outcome-note">This outcome closes the follow-up — nothing more to schedule.</p>
</template>

<script>
/**
 * DrawerOutcomeNote — the design's line under the Phone outcome. `kind` =
 * drawerNextDate.outcomeNoteKind(status): 'stop' (TeamioFollowupStatusID 3), 'done' (1 / 5), or null.
 * The same statuses hide the next date. Presentational.
 */
export default {
  name: 'DrawerOutcomeNote',
  props: {
    kind: { type: String, default: null },
    firstName: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-dro { margin: 0; font-size: 12.5px; font-weight: $fu-fw-semibold; }
.fu-dro--stop { color: $fu-danger-text; }
.fu-dro--done { color: $fu-success; }
</style>
